<template lang="html">
  <div class="">
    <v-window
      :value="window"
      touchless
    >
      <v-window-item key="0">
        <v-container
          grid-list-xl
          fluid
          pa-6
        >
          <v-layout wrap>
            <v-flex
              v-for="(stat, i) in totals"
              :key="i"
              xs12
              sm6
              md4
              xl3
            >
              <SiStatCard
                :value="(totalsValues[calculatorId] || {})[stat.id]"
                :label="stat.text"
                :icon="stat.icon"
                :color="stat.color"
                :format="v => !isNaN(v) ? Number(v).toFixed(stat.decimals || 0) : 0"
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-title class="white pt-0">
          <v-spacer />
          <v-flex
            xs12
            sm6
            md4
            pa-0
          >
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Search"
              single-line
              clearable
              hide-details
            />
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="tableHeaders"
          :items="_sortObject(calculations)"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items-per-page="10"
          :footer-props="{itemsPerPageOptions: [10, 50, 100, -1]}"
          :search="search"
          class="cursor-pointer "
          @click:row="viewCalculation($event.id)"
        >
          <template #item.report="{ item }">
            <div>
              <v-btn
                color="primary"
                class="ml-2"
                icon
                @click.stop="viewReportDialog(item.id)"
              >
                <v-icon>pageview</v-icon>
              </v-btn>
              <v-btn
                color="primary"
                icon
                @click.stop="_viewReportWindow(calculatorId, item.id)"
              >
                <v-icon>launch</v-icon>
              </v-btn>
            </div>
          </template>
          <template #item.email="{ item }">
            <span :class="{'grey--text': !item.email}">{{ item.email || 'NOT PURCHASED' }}</span>
          </template>
          <template #item.timestamp="{ item }">
            <span>{{ item.timestamp ? _formatDateTime(item.timestamp) : 'Nil' }}</span>
          </template>
          <template #item.assisted="{ item }">
            <v-icon v-if="item.assisted">
              support_agent
            </v-icon>
            <v-icon v-if="item.assigned">
              forward_to_inbox
            </v-icon>
          </template>
          <template #item.calculated="{ item }">
            <div>
              <v-icon
                v-if="item.calculated"
                color="success"
              >
                check_circle
              </v-icon>
              <v-icon
                v-else
                color="error"
              >
                error
              </v-icon>
            </div>
          </template>
        </v-data-table>
      </v-window-item>

      <v-window-item key="1">
        <CalculatorsView />
      </v-window-item>
    </v-window>
    <SiReportDialog
      v-model="viewReport"
      :calculation-id="viewCalculationId"
      :calculator-id="calculatorId"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach } from 'lodash'
import helpers from '@/mixins/helpers'
import analytics from '@/mixins/analytics'
import binder from '@/mixins/binder'
import links from '@/mixins/links'
import seen from '@/mixins/seen'

export default {
  mixins: [ helpers, links, binder, analytics, seen ],
  data () {
    return {
      viewReport: false,
      viewCalculationId: null,
      search: '',
      viewOptions: [],
      sortBy: '',
      sortDesc: true,
      sortOptions: [],
      sortAscending: true,
      calculations: {},
      tableHeaders: [
        { text: 'Open Report', value: 'report', sortable: false, width: '160px' },
        { text: 'Fund', value: 'superType' },
        { text: 'Email', value: 'email' },
        { text: 'Client Reference', value: 'client_reference' },
        { text: 'Calculation ID', value: 'id', sortable: false },
        { text: 'Variant', value: 'variant' },
        { text: 'Attributes', value: 'assisted' },
        { text: 'Timestamp', value: 'timestamp', align: 'right' },
        { text: 'Status', value: 'calculated', align: 'center', width: '20px' }
        // { text: 'Migrated', value: 'migrationSuccessful', align: 'center', width: '20px' }
      ],
      stats: {},
      totals: [
        { text: 'Purchased', id: 'purchased' || 0, icon: 'shopping_cart', color: 'success' },
        { text: 'Total Calculations', id: 'total' || 0, icon: 'bar_chart', color: 'cyan' },
        { text: 'Crashed', id: 'crashed' || 0, icon: 'error_outline', color: 'error' },
        { text: 'Rating', id: 'rating' || 0, icon: 'star', color: 'yellow darken-2', decimals: 2 }
      ],

      totalsValues: {},
      subTotalsValues: {}
    }
  },
  computed: {
    ...mapGetters(['_badgeTotals', '_user', 'culators', '_loader', '_userToken', '_calculators']),
    calculatorId () {
      return this.$route.params.sub
    },
    window () {
      return this.$route.params.id ? 1 : 0
    }
  },
  watch: {
    '$route.params.sub' () {
      this.bindCalculations()
      this._seenUpdate(this.calculatorId)
      this.setTitle()
    },
    '$route.params.id' (v) {
      if (!v) this._seenUpdate(this.calculatorId)
    },
    _calculators () {
      this.setTitle()
    }
  },
  beforeMount () {
    this.bindCalculations()
    this.setTitle()
  },
  mounted () {
    this._seenUpdate(this.calculatorId)
  },
  methods: {
    setTitle () {
      this.$store.commit('set_appBarTitle', { title: ((this._calculators || {})[this.calculatorId] || {}).name, icon: 'assessment' })
    },
    viewCalculation (id) {
      this.$router.push(`${this.$route.path}/${id}`)
    },
    viewReportDialog (id) {
      this.viewCalculationId = id
      this.viewReport = true
    },
    bindCalculations () {
      this.calculations = {}
      this.stats = {}
      this.search = ''
      this.sortBy = 'timestamp'
      this.sortDesc = true

      this.$set(this.totalsValues, this.calculatorId, { total: 0, purchased: 0, crashed: 0, rating: 0 })
      this.$set(this.subTotalsValues, this.calculatorId, { total: 0, purchased: 0, crashed: 0, rating: 0 })

      this.$bindRtdb('calculations', `calculations/_index/${this.calculatorId}`, { loader: true })
      // this.$bindxxx(rtdb.ref(`calculations/_index/${this.calculatorId}`), 'calculations', true)

      const ratingsCallback = (v) => {
          let rating = this._calculateRating(v.overall)
          this.$set(this.totalsValues[this.calculatorId], 'rating', rating)
          this.subTotalsValues[this.calculatorId].rating = Object.keys(v.overall || {}).map(k => (v.overall || {})[k]).reduce((t, cv) => { t = Number(t) + Number(cv) }, 0)
      }

      this.$bindRtdb(
        'ratings', 
        `stats/ratings/calculator/${this.calculatorId}`, 
        { callback: ratingsCallback }
      )

      const statsCallback = (v) => {
        this.stats = v
        forEach(this.totals, (total) => {
          this.$nextTick(() => {
            if (total.id !== 'rating') this.$set(this.totalsValues[this.calculatorId], total.id, ((v.totals || {})[total.id] || 0))
          })
        })
      }

      this.$bindRtdb(
        'stats', 
        `stats/calculations/${this.calculatorId}`, 
        { callback: statsCallback }
      )
      // this.$bindxxx(rtdb.ref(`stats/ratings/calculator/${this.calculatorId}`), v => {
      //   v = v || {}
      //   let rating = this._calculateRating(v.overall)

      //   this.$set(this.totalsValues[this.calculatorId], 'rating', rating)
      //   this.subTotalsValues[this.calculatorId].rating = Object.keys(v.overall || {}).map(k => (v.overall || {})[k]).reduce((t, cv) => { t = Number(t) + Number(cv) }, 0)
      // })


      // this.$bindxxx(rtdb.ref(`stats/calculations/${this.calculatorId}`), v => {
      //   this.stats = v
      //   forEach(this.totals, (total) => {
      //     this.$nextTick(() => {
      //       if (total.id !== 'rating') this.$set(this.totalsValues[this.calculatorId], total.id, ((v.totals || {})[total.id] || 0))
      //     })
      //   })
      // })
    }
  }
}
</script>

<style lang="css" scoped>

</style>
